import { useEffect, useState } from 'react';

/** Figma's mobile frames target <640px; shared so every consumer agrees. */
export const MOBILE_MAX_WIDTH_QUERY = '(max-width: 639px)';

/** Whether the viewport currently matches the mobile breakpoint (`matchMedia`). */
export function useIsMobileViewport(
  query: string = MOBILE_MAX_WIDTH_QUERY
): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mediaQueryList = window.matchMedia(query);
    const handleChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };
    setIsMobile(mediaQueryList.matches);
    mediaQueryList.addEventListener('change', handleChange);
    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, [query]);

  return isMobile;
}

export default useIsMobileViewport;
